import { render, staticRenderFns } from "./update_trait_vid_okba.vue?vue&type=template&id=6ef626b0&"
import script from "./update_trait_vid_okba.vue?vue&type=script&lang=js&"
export * from "./update_trait_vid_okba.vue?vue&type=script&lang=js&"
import style0 from "./update_trait_vid_okba.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports